import { privateAxios } from 'services/api/privateAxios';
import { adminAPI } from 'services/api/apiUrl';

export const deleteProduct = (id) =>
  privateAxios({
    method: 'delete',
    baseURL: adminAPI,
    url: `/product/${id}`,
  });
